__turbopack_context__.v({
  "bannerArrow": "_81OhzW_bannerArrow",
  "bannerButtonText": "_81OhzW_bannerButtonText",
  "bannerLink": "_81OhzW_bannerLink",
  "bannerText": "_81OhzW_bannerText",
  "closeButton": "_81OhzW_closeButton",
  "commonBanner": "_81OhzW_commonBanner",
});
